import React from "react";
import { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { PORT } from "../../config";
import { notify } from "react-notify-toast";
import DeletePopup from "./ConfirmationBox";
import { addDays } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "./UserProfile.css";
import { connect } from "react-redux";
// import { store } from "../../redux/store";
// import ImageCrops from "./ImageCrops";
// import $ from "jquery";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import { API } from "../../API";
import { handleLogErrorToSlack } from "../../Helper";
import { CircularProgress } from "@mui/material";

const URL = PORT;

export class PoliceChkForm extends Component {
  constructor(props) {
    super(props);

    if (!this.props.user) {
      window.location = "./login";
    }

    this.state = {
      deletepolice_checkPopup: false,
      filetype: true,
      file: null,
      preview: null,
      show: false,
      borderRadius: 0,
      width: 200,
      height: 200,
      scale: 1,
      image: "",
      imageName: "",
      allowZoomOut: false,
    };
  }

  uploadDocument = () => {
    document.getElementById("police_check").click();
  };

  onFileUpload = (fileName, url) => {
    this.props.handleStateChange("police_check_filename", fileName);
    this.props.handleStateChange("police_check_url", url);
  };

  saveFile = async (file, filename) => {
    this.setState({
      isLoading: true
    });
    const fileName = 'police_check';

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", `${fileName}`)
      const response = await API.uploadCompressedFileToS3(formData)
  
      const url = response?.data?.data
      const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
      const suffix = url.substring(cut_length, url.length);
      const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
      const new_url = prefix + suffix;
      this.onFileUpload(file.name, new_url);
      this.setState({
        isLoading: false
      });
    } catch (error) {
      this.setState({
        isLoading: false
      });
      handleLogErrorToSlack(error, true);
      notify.show(JSON.stringify(error), "error");
    }
  };

  validateFile = (file, filename) => {
    let isValid = false;
    if (file !== null && file !== undefined) {
      isValid = true;
    }
    return isValid;
  };

  handlePoliceCheckFileChange = () => {
    var isValidFile = false;
    let policecheckFile = this.uploadPoliceCheck.files[0];
    let filesize = this.uploadPoliceCheck.files[0].size >> 10

    isValidFile = this.validateFile(policecheckFile, "police_check");
    if (isValidFile) {
      this.saveFile(policecheckFile, "police_check");
    }
  };

  deleteFile = (isDelete, fileName, popupStatus) => {
    var popUpState = "delete" + fileName + "Popup";
    if (isDelete) {
      notify.show("File deleted successfully");
      this.props.handleStateChange("police_check_filename", null);
      this.props.handleStateChange("police_check_url", null);
    } else {
    }
    this.setState({ [popUpState]: popupStatus });
  };

  // onFileLoad = (e) => {
  //   this.setState({ file: e });
  //   this.setState({ Name: e.name });
  //   // alert("Hello");
  //   var isValidFile = false;
  //   let policeCheck = e;
  //   isValidFile = this.validateFile(policeCheck, "police_check");
  //   //this.fileType(wwccFile);
  //   // if (isValidFile) {
  //   //   this.saveFile(wwccFile, "wwcc_img");
  //   // }
  // };

  fileType = () => {
    let police_check = this.uploadPoliceCheck.files[0];
    this.setState({ image: this.uploadPoliceCheck.files[0] });
    this.setState({ imageName: police_check.name });

    let isPdf = true;
    let filesplit = police_check.name.split(".");
    let filetype = filesplit[filesplit.length - 1];
    if (filetype !== "pdf") {
      isPdf = false;
    }
    return isPdf;
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="auth-text-top mb-5">
            <ButtonContainer label="Police Check Type">
              <CheckableButton
                id="rbEmployment"
                name="police_check_type"
                title="Employement/Professional"
                onChange={this.props.handleRadioChange}
                checked={
                  this.props.state.police_check_type ===
                  "Employement/Professional"
                }
                required
              >
                Employment/Professional
              </CheckableButton>
              <CheckableButton
                id="rbVolunteer"
                name="police_check_type"
                title="Volunteer/Student Placement"
                onChange={this.props.handleRadioChange}
                checked={
                  this.props.state.police_check_type ===
                  "Volunteer/Student Placement"
                }
                required
              >
                Volunteer/Student Placement
              </CheckableButton>
            </ButtonContainer>

            {/* Police Check Result */}
            <FormDropdown
              label="Police Check Result"
              id="police_check_result"
              name="police_check_result"
              onChange={this.props.handleFormFieldChange}
              value={this.props.state.police_check_result || ""}
              required
            >
              <option disabled value="">
                Please Select
              </option>
              <option>Non disclosable outcomes</option>
              <option>Disclosable outcomes</option>
            </FormDropdown>

            <FormField
              label="Police Check Issuing Organisation"
              id="police_check_issuing_organisation"
              name="police_check_issuing_organisation"
              onChange={this.props.handleFormFieldChange}
              value={this.props.state.police_check_issuing_organisation}
              maxLength="120"
              required
              placeholder="Insert the police check issuing organisation"
            />

            {/* Police Check Release Date */}
            <FormDatePicker
              label="Police Check Release Date"
              id="police_check_release"
              selected={this.props.state.police_check_release}
              placeholderText={new Date()
                .toLocaleDateString()
                .split(/\//)
                .join("-")}
              showYearDropdown
              showMonthDropdown
              isClearable
              showPopperArrow={false}
              maxDate={addDays(new Date(), 0)}
              dropdownMode="select"
              dateFormatCalendar="MMMM"
              dateFormat="dd-MM-yyyy"
              yearDropdownItemNumber={10}
              scrollableYearDropdown
              onChange={this.props.handleDateChange}
              required
            />

            <FormField
              label="Upload Police Check"
              id="flPoliceCheck"
              name="userPoliceCheck"
              disabled
              required
              placeholder={
                this.props.state.police_check_filename
                  ? this.props.state.police_check_filename
                  : "Add a PDF Copy of your Police Check Form"
              }
              header={
                <>
                  {this.props.state.police_check_status ? (
                    <HoverIcon
                      icon="check circle"
                      color="green"
                      type="success"
                      text="This document has been verified!"
                    />
                  ) : (
                    <HoverIcon
                      icon="check circle"
                      color="grey"
                      text="This document has not been verified yet!"
                    />
                  )}
                  <HoverIcon
                    icon="info circle"
                    color="grey"
                    text="Please upload a PDF file less than 600KB."
                  />
                </>
              }
              sideButton={{
                id: "btnUpload_police_check",
                type: "button",
                label: "Upload",
                onClick: this.uploadDocument,
                disabled: this.props.state.police_check_filename || this.state.isLoading,
              }}
              footer={
                this.props.state.police_check_filename ? (
                  <div className="text-left d-flex">
                    {/* <Link
                      to={{
                        pathname: `/pdfViewer?id=${this.props.state.police_check_url}`,
                      }}
                      target="_blank"
                    >
                      <p className="uploaded-file-name mt-1 ml-1">
                        {this.props.state.police_check_filename}
                      </p>
                    </Link> */}
                    <a href={`/NavigateToFileViewer?fileurl=${this.props.state.police_check_url}`} target='_blank'>
                      <p className="uploaded-file-name mt-1 ml-1">
                        {this.props.state.police_check_filename}
                      </p>
                    </a>
                    <i
                      className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                      onClick={() =>
                        this.setState({ deletepolice_checkPopup: true })
                      }
                    ></i>
                    {this.state.deletepolice_checkPopup && (
                      <DeletePopup
                        togglePopup={(isDelete) =>
                          this.deleteFile(isDelete, "police_check", false)
                        }
                      />
                    )}
                  </div>
                ) : (
                  ""
                )
              }
            >
              {
                this.state.isLoading && (
                  <CircularProgress />
                )
              }
              <input
                type="file"
                id="police_check"
                name="police_check"
                onChange={() =>
                  this.fileType()
                    ? this.handlePoliceCheckFileChange()
                    : this.setState({
                      filetype: false,
                    })
                }
                ref={(ref) => {
                  this.uploadPoliceCheck = ref;
                }}
                style={{ display: "none" }}
                accept=".pdf"
              />
            </FormField>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};

export default connect(mapStateToProps)(PoliceChkForm);
